import { Component, ChangeDetectionStrategy } from "@angular/core";
import { ProductAnalysisComponent } from "./product-analysis.component";

@Component({
  template: ` <app-product-analysis /> `,
  imports: [ProductAnalysisComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductAnalysisPageComponent {}
